// PNR URL geliştirmeleri yapılana kadar statik URL kullanımı
const PNR_SEARCH_URLS = {
  tr: "/kullanici/otobus-biletleri/?BookingsType={BookingsType}&PNRNumber={PNRNumber}",

  ru: "/ru/polzovatel/bilety-na-avtobus?BookingsType={BookingsType}&PNRNumber={PNRNumber}",

  en: "/user/bus-bookings?languagecode=ru&BookingsType={BookingsType}&PNRNumber={PNRNumber}",

  de: "/benutzer/bus-buchung?languagecode=ru&BookingsType={BookingsType}&PNRNumber={PNRNumber}",

  az: "/az/istifadeci/avtobus-biletleri?languagecode=ru&BookingsType={BookingsType}&PNRNumber={PNRNumber}",

  ar: "/almustaemal/hujuzat-alhafilat?languagecode=az&PNRNumber={PNRNumber}",
};

const PNR_FAQ_URLS = {
  tr: "/sikca-sorulan-sorular",
  ru: "/ru/chasto-zadavaemye-voprosy",
  en: "/frequently-asked-questions",
  de: "/haufig-gestellte-fragen",
  az: "/az/tez-tez-verilen-suallar",
  ar: "/asyilat-mukarara"
};

const DEFAULT_LOCALE = "tr";
const BASE_URL = "https://www.turna.com";

/**
 * PNR numarasına göre yönlendirme URL'si oluşturur ve sayfayı yönlendirir
 * @param {string} locale - Dil kodu (tr, en, ar, de, az, ru)
 * @param {string} bookingsType - Rezervasyon tipi
 * @param {string} pnrNumber - PNR numarası
 */
export const generatePnrUrl = (locale, bookingsType, pnrNumber) => {
  try {
    const template = PNR_SEARCH_URLS[locale] || PNR_SEARCH_URLS[DEFAULT_LOCALE];

    const pnrSearchUrl = template
      .replace("{BookingsType}", bookingsType)
      .replace("{PNRNumber}", pnrNumber);

    //window.location.href = `${BASE_URL}${pnrSearchUrl}`;
    window.location.href = `${pnrSearchUrl}`;
  } catch (error) {
    console.error("PNR URL oluşturulurken hata:", error);
  }
};

export const generatePnrFaqUrl = (locale) => {
  try {
    const template = PNR_FAQ_URLS[locale] || PNR_FAQ_URLS[DEFAULT_LOCALE];
    //window.location.href = `${BASE_URL}${template}`;
    window.location.href = `${template}`;
  } catch (error) {
    console.error("PNR FAQ URL oluşturulurken hata:", error);
  }
};